import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import PatientsTable from "../tables/PatientsTable";
import { RiCalendar2Fill } from "react-icons/ri";
import { AiOutlinePlus } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { get } from "../../utility/fetch";
import TagInputs from "../layouts/TagInputs";
// import ReferralModal from "../modals/RefferalModal";
import Spinner from "../UI/Spinner";
import { usePatient } from "../../contexts";
import Pagination from "../layouts/Pagination";
import ClientList from "../layouts/ClientList";
import LabServiceModal from "../modals/LabServiceModal";
import BulkLabServicesUploadModal from "../modals/BulkLabServicesUploadModal";
import CostSetupTable from "../tables/CostSetupTable";
import { set } from "react-hook-form";
// import VitalPatientsTable from "../tables/VitalPatientTable";
// import AdmitCheck from "./Patient/AdmitCheck";
// import PatientsAppointTable from "../tables/PatientsAppointTable";

function Patients() {
  const [allPatients, setAllPatients] = useState([]);
  const [vitalPatients, setVitalPatients] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [payload, setPayload] = useState('');
  const [filterSelected, setFilterSelected] = useState("ItemName");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPagesVital, setTotalPagesVital] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [admittedPatients, setAdmittedPatients] = useState([])
  const [appointPatients, setAppointPatients] = useState([])
  const [checkinPatients, setCheckinPatients] = useState(false)
  const [nurseTypes, setNurseTypes] = useState('admin');
  const [editDetails, setEditDetails] = useState(null);
  const [searchTermDate, setSearchTermDate] = useState(null);



  const itemsPerPage = 10;

  const { setHmoDetails, patientId, nurseRoles } = usePatient();

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      getAllPatients(newPage)
      setCurrentPage(newPage);
    }
  };


  const generatePageNumbers = (currentPage, totalPages) => {
    let pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        pages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
      }
    }
    return pages;
  };

  const closeModal = () => {
    setEditDetails(null);
    setIsModalOpen(false);
  };

  const selectRecord = () => () => {
    setIsModalOpen(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  let navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const CustomInput = ({ value, onClick }) => (
    <button
      onClick={onClick}
      onKeyDown={(e) => e.preventDefault()}
      className="custom-datepicker-input flex gap-6 flex-v-center"
    >
      {isToday(selectedDate) ? "Today" : formatDate(selectedDate)}
      <RiCalendar2Fill />
    </button>
  );

  // const getAllAdmittedPatients = async (currentPage) => {
  //   setLoading(true);
  //   try {
  //     let res = await get(`/patients/admitted-patients?pageNumber=${currentPage}&pageSize=10`);
  //     setAdmittedPatients(res?.data);
  //     setTotalPages(res?.data?.metadata?.totalPages);
  //   } catch (error) {
  //     console.error('Error fetching all patients:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getAllPatients = async (page = currentPage) => {
    setLoading(true);
    try {
      let res = await get(`/internallabservice/list/${page}/${itemsPerPage}`);
      setAllPatients(res?.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  // const getAppointmentPatients = async () => {
  //   setLoading(true);
  //   try {
  //     let res = await get(`/Appointment/get-pending-appointments?pageIndex=${currentPage}&pageSize=${itemsPerPage}`);
  //     setAppointPatients(res?.data);
  //     setTotalPages(res?.pageCount);
  //   } catch (error) {
  //     console.error('Error fetching all patients:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const getPatientsAwaitingVital = async (searchParam) => {
  //   setLoading(true);
  //   try {

  //     let res = await get('/internallabservice/list/1/10');
  //     console.log(res);
  //     setVitalPatients(res?.data);
  //     setTotalPagesVital(res?.pageCount);
  //   } catch (error) {
  //     console.error('Error fetching all patients:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const searchPatients = async (searchParam) => {
    setLoading(true);
    try {
      let res = await get(`/internallabservice/filter-list/${filterSelected}/${searchParam}/${currentPage}/${itemsPerPage}`);
      setAllPatients(res?.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    searchPatients(searchTerm)
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "filter") {
      setFilterSelected(value);
    } else if (name === 'searchDate') {
      const formattedDate = formatDate(value);
      setSearchTermDate(value)
    } else {
      setSearchTerm(value);
      // searchPatients(value);
    }
  };


  const handleEditDetails = (data) => {
    console.log(data)
    setEditDetails({
      name: data.name,
      cost: data.cost,
      description: data.description,
      id: data.id
    });
    setIsModalOpen(true);
  }

  // useEffect(() => {

  //   getAllPatients(currentPage);

  // }, [currentPage, searchTerm, nurseTypes, checkinPatients]);

  useEffect(() => {
    if (payload) {
      searchPatients(payload);
    } else {
      getAllPatients();
    }
  }, [filterSelected, payload]);

  const filterOptions = [
    { value: "ItemName", name: "Item Name" }
  ];

  const MenuItem = ({ item: { title, href, icon, children }, pathname, onMenuItemClick }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const handleClick = (e) => {
      e.stopPropagation();
      if (children) {
        setShowSubMenu((prev) => !prev);
        return;
      }
      onMenuItemClick(title, href);
    };

    const handleSubItemClick = (sub) => {
      onMenuItemClick(sub.title, sub.href);
    };

    return (
      <>
        <li className={`${pathname === href ? "active" : ""} pointer`} onClick={(e) => handleClick(e)}>
          {icon}
          <span className="title m-l-20">{title}</span>
          {children && (
            <IoIosArrowBack
              className={`${showSubMenu ? "open" : ""} arrow`}
              onClick={(e) => {
                e.stopPropagation();
                setShowSubMenu((prev) => !prev);
              }}
            />
          )}
        </li>
        {children && showSubMenu && (
          <ul
            className="sub-menu show"
            style={{
              padding: "10px 0 10px 20px",
              margin: 0,
              backgroundColor: "#f8f9fa", // Light gray background for sub-menu
              borderRadius: "4px",
              listStyle: "none",
            }}
          >
            {children.map((sub) => (
              <li
                key={sub.title}
                className={`${pathname === sub.href ? "active" : ""} pointer menu-items`}
                onClick={() => handleSubItemClick(sub)}
                style={{
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  transition: "background 0.3s, color 0.3s",
                  color: pathname === sub.href ? "#ffffff" : "#28a745", // White text when active, green when inactive
                  backgroundColor: pathname === sub.href ? "#28a745" : "transparent", // Green background when active
                }}
              >
                {sub.title}
              </li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return (
    <div className="w-100 m-t-40 m-l-20">
      <>
        {
          (
            <div className="flex flex-v-center space-between wrap m-t-20">
              <h3>Cost Setup</h3>
              <div className="flex flex-60 flex-v-center gap-8">
                <TagInputs onChange={handleChange} name="name" label="Search" />
                <TagInputs
                  onChange={handleChange}
                  name="filter"
                  label="Filter By"
                  type="select"
                  options={filterOptions}
                />
                <button style={{marginTop:"10px"}}  onClick={handleSearch} className="submits-btn">
                  Search
                </button>
                <button
                  onClick={() => { setIsBulkUploadModalOpen(true); }}
                  style={{marginTop:"10px"}}
                  className="btn no-wrap flex flex-h-center gap-10 flex-v-center"
                >
                  <AiOutlinePlus size={24} color="white" />
                  <p className="m-r-10 no-wrap">Bulk Upload Lab Services</p>
                </button>
                <button
                  onClick={() => { setIsModalOpen(true); setEditDetails(null); }}
                  style={{marginTop:"10px"}}
                  className="btn no-wrap flex flex-h-center gap-10 flex-v-center"
                >
                  <AiOutlinePlus size={24} color="white" />
                  <p className="m-r-10 no-wrap">Create a Lab Service</p>
                </button>
              </div>
            </div>
          )
        }
      </>
      <div>

        {(
          <>

            <CostSetupTable setEditDetails={handleEditDetails} loading={loading} getInternalLabService={getAllPatients} data={allPatients} currentPage={currentPage} itemsPerPage={itemsPerPage} />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              generatePageNumbers={generatePageNumbers}
            />

          </>

        )}
      </div>
      {isBulkUploadModalOpen &&
        <BulkLabServicesUploadModal
          onClose={() => setIsBulkUploadModalOpen(false)}
          onSuccess={getAllPatients}
        />
      }
      {isModalOpen &&
        <LabServiceModal
          getInternalLabService={getAllPatients}
          closeModal={closeModal}
          editDetails={editDetails}
        />
      }
    </div>
  );
}

export default Patients;
